import { userAccount, userRegister } from './user-account';

export const en = {
  userAccount,
  userRegister,
};
